import { gql } from '@apollo/client';

export const GET_ADMIN_USER_ANALYTICS = gql`
  query GetAdminUserAnalytics {
    getAdminUserAnalytics {
      totalUsers
      totalCreators
      totalBrands
      onboardedUsers
      dropOffUsers
      failedSignups
    }
  }
`;
